import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../../reducer/CombineReducer";
import { IScheduleInstanceType, SchedulingModes } from "../CreateSchedule/redux/Types";
import { Accordion, Table } from "../../../Common/UI/Index";
import { AccordionType } from "../../../Common/UI/Accordion/Types";
import { PopulateTable } from "./Data";
import "../SchedulingEntries/SchedulingDetails/Common/Style.scss";
import "./Style.scss";

interface IProps {
  tableData: IScheduleInstanceType[];
}

// Responsible for rendering scgedule instance table view
export const ScheduleInstanceTableView: React.FC<IProps> = (props: IProps) => {
  const { tableData } = props;
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const isViewMode = scheduling.mode === SchedulingModes.VIEW;
  const [detailsAccordionOpen, setDetailsAccordionOpen] = useState<boolean>(false);

  // To scroll the instance table to the top
  React.useEffect(() => {
    if (isViewMode) {
      const element = document.querySelector(".ebt-new-schedule__content");
      if (element) {
        element.scrollTop = 0;
      }
    }
  }, [isViewMode]);

  /**
   * Callback function onclick of schedule table details accordion
   */
  const onScheduleInstanceAccordionClick = (): void => {
    setDetailsAccordionOpen(!detailsAccordionOpen);
  };

  const accordionData: AccordionType[] = [
    {
      name: "Schedule recurrence list",
      content: <Table
        id="scheduleInstanceTableId"
        tableData={PopulateTable(tableData, dispatch)}
        emptyStateText={translate("OutputConfig.FinalOutputTable.NoEntries")}
      />,
      className: "execution-details-container__execution-details-accordion",
      onAccordionClick: onScheduleInstanceAccordionClick
    },
  ];

  return (
    <Accordion
      data={accordionData}
      accordionId="schedule-instance"
      defaultOpenSection={isViewMode ? 0 : 1}    />
  );
};
